import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, KiloClassCoachRole, KiloClassCoachRoleWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateClassCoachRole(): UseMutationResult<
  AxiosResponse<KiloClassCoachRole>,
  AxiosError<ErrorMessage>,
  KiloClassCoachRoleWrite
> {
  const queryClient = useQueryClient();

  const updateClassCoachRole = (
    payload: KiloClassCoachRoleWrite,
  ): Promise<AxiosResponse<KiloClassCoachRole>> => {
    return client.put(`kilo-class-coach-roles/${payload?.kiloClassCoachRoleId}/`, payload);
  };

  return useMutation(updateClassCoachRole, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['classCoachRoles'],
      });
      queryClient.invalidateQueries({
        queryKey: ['classPayRateLookups'],
      });
    },
  });
}
